/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 納品（受入）可能フラグ（金曜日）
 * @export
 * @interface EnableArrivalFri
 */
export interface EnableArrivalFri {
}

/**
 * Check if a given object implements the EnableArrivalFri interface.
 */
export function instanceOfEnableArrivalFri(value: object): value is EnableArrivalFri {
    return true;
}

export function EnableArrivalFriFromJSON(json: any): EnableArrivalFri {
    return EnableArrivalFriFromJSONTyped(json, false);
}

export function EnableArrivalFriFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableArrivalFri {
    return json;
}

export function EnableArrivalFriToJSON(json: any): EnableArrivalFri {
    return EnableArrivalFriToJSONTyped(json, false);
}

export function EnableArrivalFriToJSONTyped(value?: EnableArrivalFri | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

